import { orderBy } from "lodash";
import { ContentType, httpDelete, httpGet, httpGetList, httpPost, httpPut } from "../../common/network/fetch";
import { User } from "../model/user";
import { UserSummary } from "../model/user-summary";
import { UserWithWarehouseDetails } from "../model/user-with-warehouse-details";

class UsersService {

    public async getUsers() {
        const userList = await httpGetList<UserWithWarehouseDetails>({url: "/users"});
        return (orderBy(userList.map(user => new UserWithWarehouseDetails(user)), ["sortColumn"]));
    }

    public async getUser(userId: string) {
        return new User(await httpGet<User>({url: `/users/${userId}`}));
    }

    public async register(userName: string, email: string, contactData: string, password: string, warehouseCode: string,
                          roles: string[], canGenerateLabelsOnTestEnvironment: boolean, ownerGuids: string[],
                          attributes: string[], operationCodes: string[]) {
        return httpPost<string>({url: "/users/register", data: {
            userName, email, password, contactData, warehouseId: warehouseCode, roles, canGenerateLabelsOnTestEnvironment,
                ownerGuids, attributes, operationCodes,
        }}, false);
    }

    public async saveUser(userId: string, userName: string, email: string, contactData: string, warehouseCode: string | undefined,
                          roles: string[], canGenerateLabelsOnTestEnvironment: boolean, ownerGuids: string[],
                          isLocked: boolean, attributes: string[], operationCodes: string[]) {
        return httpPut({url: `/users/${userId}`, data: {
                id: userId, userName, contactData, email, warehouseId: warehouseCode, roles, canGenerateLabelsOnTestEnvironment,
                ownerGuids, isLocked, attributes, operationCodes,
            }}, false);
    }

    public async changePassword(userId: string, password: string) {
        return httpPut({url: `/users/${userId}/password`, data: password, contentType: ContentType.APPLICATION_JSON});
    }

    public async deleteUser(userId: string) {
        return httpDelete({url: `/users/${userId}`}, false);
    }

    public async getOwners() {
        return await httpGetList<UserSummary>({url: "/admin/user/list-administrator"});
    }

    public async createResetPasswordToken(userName: string) {
        return await httpPost({url: "/users/password/forgot", data: {userName}});
    }

    public async verifyResetPasswordToken(userName: string, token: string) {
        return await httpPost({url: "/users/password/token/validate", data: {userName, token}});
    }

    public async resetPasswordChange(userName: string, token: string, password: string) {
        return await httpPost({url: "/users/password/change", data: {userName, token, password}});
    }
}

export const usersService = new UsersService();
